import { Page } from "@/models/page-models/Page";

export const GoodsTransferRequests: Page = {
  "path": "goods-transfer-requests",
  "name": "Internal Material Transfer",
  "props": {
    "data": {
      "title": "Internal Material Transfer",
      "printable": "FALSE",
      "url": "goods-transfer-requests",
      "groups": [
        {
          "type": "tabs",
          "tabItems": [
            {
              "tabName": "FG",
              "bracketValueFormula": "fn(LENGTH,{{fetchedData.FgRequests}})",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "FG",
                      "disabled": "FALSE",
                      "items": "fetchedData.FgRequests",
                      "tableType": "static",
                      "showActions": true,
                      "headers": [
                        {
                          "value": "__item.rawMaterial._id",
                          "text": "Good#"
                        },
                        {
                          "value": "__item.rawMaterial.factoryTicket.order.product.customerName",
                          "text": "Customer"
                        },
                        {
                          "value": "__item.rawMaterial.factoryTicket.order._id",
                          "text": "Order #"
                        },
                        {
                          "value": "__item.rawMaterial.factoryTicket.order.product",
                          "text": "Product Description",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.rawMaterial.factoryTicket.order.product}})"
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Quantity to be Moved",
                          "type": "formula",
                          "formula": "fn(HELPER_FN,numFormat,fn(HELPER_FN,kgToSellingUnitQuantity,{{__item.rawMaterial.factoryTicket.order}},{{__item.rawMaterial}},{{__item.quantity}}))"
                        },
                        {
                          "value": "__item.rawMaterial.factoryTicket.order.product.unit.unit2",
                          "text": "Selling Unit"
                        },
                        {
                          "value": "__item.createdAt",
                          "text": "Date Created",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        },
                        {
                          "value": "__item.actions",
                          "text": "Actions",
                          "type": "actions",
                          "width": 150,
                          "actions": [
                            {
                              "label": "Approve",
                              "priority": "main",
                              "onClick": [
                                {
                                  "executionOrder": 1,
                                  "name": "approveTransferRequest"
                                }
                              ]
                            },
                            {
                              "label": "Reject",
                              "priority": "menu",
                              "onClick": [
                                {
                                  "executionOrder": 1,
                                  "pageFunction": {
                                    "name": "rejectTransferRequest",
                                    "type": "fnSubmit",
                                    "arg1Key": "apiUrl",
                                    "arg1Value": "/api/v1/goods/transfer/{{__item._id}}/reject",
                                    "arg2Key": "postData",
                                    "arg2Value": "{}",
                                    "arg3Key": "refreshPage",
                                    "arg3Value": "TRUE"
                                  },
                                  "name": "rejectTransferRequest"
                                }
                              ]
                            },
                            {
                              "label": "Go To Factory Ticket",
                              "priority": "menu",
                              "onClick": [
                                {
                                  "executionOrder": 1,
                                  "name": "resetFormData"
                                },
                                {
                                  "executionOrder": 2,
                                  "name": "getFactoryTicketData"
                                }
                              ]
                            }
                          ],
                          "useMenu": true
                        }
                      ]
                    }
                  ]
                }
              ],
              "showIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_INBOUND_WAREHOUSE))"
            },
            {
              "tabName": "WIP",
              "bracketValueFormula": "fn(LENGTH,{{fetchedData.WipRequests}})",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "WIP",
                      "disabled": "FALSE",
                      "items": "fetchedData.WipRequests",
                      "headers": [
                        {
                          "value": "__item.rawMaterial._id",
                          "text": "Good#"
                        },
                        {
                          "value": "__item.rawMaterial.factoryTicket.order.product.customerName",
                          "text": "Customer"
                        },
                        {
                          "value": "__item.rawMaterial.factoryTicket.order.product",
                          "text": "Product Description",
                          "formula": "fn(HELPER_FN,productAlias,{{__item.rawMaterial.factoryTicket.order.product}})"
                        },
                        {
                          "value": "__item.rawMaterial.factoryTicket.processes",
                          "text": "Last Process",
                          "formula": "fn(HELPER_FN,lastProcess,{{__item.rawMaterial.factoryTicket.processes}},{{__item.rawMaterial._id}})"
                        },
                        {
                          "value": "__item.locationFrom",
                          "text": "Location",
                          "type": "formula",
                          "formula": "{{__item.locationFrom}} -> {{__item.locationTo}}"
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Quantity to be Moved",
                          "type": "formula",
                          "filterType": "unit",
                          "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterial.rawMaterialUnit}},'),==,'SQM'),{{fn(STANDARD_FUNCTIONS,kgToSQM,{{__item.quantity}},{{__item.rawMaterial}})}},{{__item.quantity}})",
                          "filterParam": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterial.rawMaterialUnit}},'),==,'SQM'),SQM,KG)"
                        },
                        {
                          "value": "__item.createdAt",
                          "text": "Date Created",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        },
                        {
                          "value": "__item.actions",
                          "text": "Actions",
                          "type": "actions",
                          "width": 150,
                          "actions": [
                            {
                              "label": "Approve",
                              "priority": "main",
                              "onClick": [
                                {
                                  "executionOrder": 1,
                                  "name": "approveTransferRequest"
                                }
                              ]
                            },
                            {
                              "label": "Reject",
                              "priority": "menu",
                              "onClick": [
                                {
                                  "executionOrder": 1,
                                  "pageFunction": {
                                    "name": "rejectTransferRequest",
                                    "type": "fnSubmit",
                                    "arg1Key": "apiUrl",
                                    "arg1Value": "/api/v1/goods/transfer/{{__item._id}}/reject",
                                    "arg2Key": "postData",
                                    "arg2Value": "{}",
                                    "arg3Key": "refreshPage",
                                    "arg3Value": "TRUE"
                                  },
                                  "name": "rejectTransferRequest"
                                }
                              ]
                            },
                            {
                              "label": "Go To Factory Ticket",
                              "priority": "menu",
                              "onClick": [
                                {
                                  "executionOrder": 1,
                                  "name": "resetFormData"
                                },
                                {
                                  "executionOrder": 2,
                                  "name": "getFactoryTicketData"
                                }
                              ]
                            }
                          ],
                          "useMenu": true
                        }
                      ],
                      "tableType": "static",
                      "showActions": true
                    }
                  ]
                }
              ],
              "showIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE),||,fn(MATCH_ROLE,QA_MANAGER)))"
            },
            {
              "tabName": "RM",
              "bracketValueFormula": "fn(LENGTH,{{fetchedData.RmRequests}})",
              "rows": [
                {
                  "name": "1",
                  "pageItems": [
                    {
                      "type": "table",
                      "label": "RM",
                      "disabled": "FALSE",
                      "items": "fetchedData.RmRequests",
                      "tableType": "static",
                      "showActions": true,
                      "headers": [
                        {
                          "value": "__item.rawMaterial._id",
                          "text": "Good#"
                        },
                        {
                          "value": "__item.rawMaterial",
                          "text": "RM Details",
                          "formula": "fn(HELPER_FN,goodsName,{{__item.rawMaterial}})"
                        },
                        {
                          "value": "__item.locationFrom",
                          "text": "Location",
                          "type": "formula",
                          "formula": "{{__item.locationFrom}} -> {{__item.locationTo}}"
                        },
                        {
                          "value": "__item.quantity",
                          "text": "Quantity to be Moved",
                          "type": "formula",
                          "filterType": "unit",
                          "formula": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterial.rawMaterialUnit}},'),==,'SQM'),{{fn(STANDARD_FUNCTIONS,kgToSQM,{{__item.quantity}},{{__item.rawMaterial}})}},{{__item.quantity}})",
                          "filterParam": "fn(CONDITIONAL,fn(LOGICAL,fn(CONCAT,',{{__item.rawMaterial.rawMaterialUnit}},'),==,'SQM'),SQM,KG)"
                        },
                        {
                          "value": "__item.createdAt",
                          "text": "Date Created",
                          "type": "date",
                          "formula": "fn(HELPER_FN,dateFormat,{{__item.createdAt}})"
                        }
                      ],
                      "selectableUniqueId": "_id",
                      "groupActions": [
                        {
                          "label": "Approve",
                          "priority": "main",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "approveTransferRequest",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/goods/transfer/{{__item._id}}/approve",
                                "arg2Key": "postData",
                                "arg2Value": "{}"
                              },
                              "name": "approveTransferRequest"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getPendingTransferRequests",
                              "executeOnce": true
                            },
                            {
                              "executionOrder": 3,
                              "name":"getRmRequests",
                              "executeOnce": true
                            }
                          ]
                        },
                        {
                          "label": "Reject",
                          "priority": "menu",
                          "onClick": [
                            {
                              "executionOrder": 1,
                              "pageFunction": {
                                "name": "rejectTransferRequest",
                                "type": "fnSubmit",
                                "arg1Key": "apiUrl",
                                "arg1Value": "/api/v1/goods/transfer/{{__item._id}}/reject",
                                "arg2Key": "postData",
                                "arg2Value": "{}"
                              },
                              "name": "rejectTransferRequest"
                            },
                            {
                              "executionOrder": 2,
                              "name": "getPendingTransferRequests",
                              "executeOnce": true
                            },
                            {
                              "executionOrder": 3,
                              "name":"getRmRequests",
                              "executeOnce": true
                            }
                          ]
                        }
                      ],
                      "neverHideActionBar":true
                    }
                  ]
                }
              ],
              "showIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE),||,fn(MATCH_ROLE,QA_MANAGER)))"
            }
          ]
        },
        {
          "type": "popupGroup",
          "label": "Factory Ticket",
          "popupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.selectedOrderNo",
                  "label": "Select Order",
                  "disabled": "TRUE",
                  "showIf": "{{formData.selectedOrderDetails}}",
                  "inputType": "formula",
                  "formula": "fn(HELPER_FN,orderDescription,{{formData.selectedOrderDetails}})"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "custom_FtOrderDetails",
                  "variable": "formData.selectedOrderDetails",
                  "disabled": "TRUE",
                  "showIf": "{{formData.selectedOrderDetails}}"
                }
              ]
            },
            {
              "name": "3",
              "pageItems": [
                {
                  "type": "custom_FtProcesses",
                  "variable": "formData.processes",
                  "label": "Processes",
                  "disabled": "TRUE",
                  "showIf": "{{formData.factoryTicket.order}}",
                  "items": "formData.processes",
                  "config": {
                    "orderDetailsVariable": "formData.selectedOrderDetails",
                    "formVariable": "formData.factoryTicket",
                    "fixedWidth": true
                  }
                }
              ]
            }
          ],
          "width": "fit-content"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "name": "getPendingTransferRequests"
      },
      {
        "executionOrder": 2,
        "name":"getFgRequests",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,CUSTOMER_SERVICE_INBOUND_WAREHOUSE))"
      },
      {
        "executionOrder": 2,
        "name":"getWipRequests",
        "executeIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE),||,fn(MATCH_ROLE,QA_MANAGER)))"
      },
      {
        "executionOrder": 2,
        "name":"getRmRequests",
        "executeIf": "fn(NOT,fn(LOGICAL,fn(MATCH_ROLE,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE),||,fn(MATCH_ROLE,QA_MANAGER)))"
      }
    ],
    "functions": [
      {
        "name": "getPendingTransferRequests",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/goods/transfer/pending",
        "arg2Key": "storeInVar",
        "arg2Value": "fetchedData.transferRequests"
      },
      {
        "name": "filterWipRequests",
        "type": "fnFilterArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.transferRequests.data",
        "arg2Key": "searchKey",
        "arg2Value": "rawMaterial.status",
        "arg3Key": "searchValue",
        "arg3Value": "WIP"
      },
      {
        "name": "filterFgRequests",
        "type": "fnFilterArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.transferRequests.data",
        "arg2Key": "searchKey",
        "arg2Value": "rawMaterial.status",
        "arg3Key": "searchValue",
        "arg3Value": "FG"
      },
      {
        "name": "getWipRequests",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "filterWipRequests",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.WipRequests"
      },
      {
        "name": "getFgRequests",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "filterFgRequests",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.FgRequests"
      },
      {
        "name": "filterRmRequests",
        "type": "fnFilterArray",
        "arg1Key": "sourceVariable",
        "arg1Value": "fetchedData.transferRequests.data",
        "arg2Key": "searchKey",
        "arg2Value": "rawMaterial.status",
        "arg3Key": "searchValue",
        "arg3Value": "RM"
      },
      {
        "name": "getRmRequests",
        "type": "fnCopyData",
        "arg1Key": "sourceFn",
        "arg1Value": "filterRmRequests",
        "arg2Key": "destinationKey",
        "arg2Value": "fetchedData.RmRequests"
      },
      {
        "name": "approveTransferRequest",
        "type": "fnSubmit",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/goods/transfer/{{__item._id}}/approve",
        "arg2Key": "postData",
        "arg2Value": "{}",
        "arg3Key": "refreshPage",
        "arg3Value": "TRUE"
      },
      {
        "name": "getFactoryTicketData",
        "type": "fnGetData",
        "arg1Key": "apiUrl",
        "arg1Value": "/api/v1/factoryticket/get?id={{__item.rawMaterial.factoryTicket._id}}",
        "arg2Key": "storeInVar",
        "arg2Value": "formData",
        "arg3Key": "sourceTransformationFn",
        "arg3Value": "transformFactoryTicketData",
        "arg4Key": "fnsAfterSubmit",
        "arg4Value": "openFTPopup"
      },
      {
        "name": "transformFactoryTicketData",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "factoryTicket": "__selectedObject.data.0",
          "selectedOrderNo": "__selectedObject.data.0.order._id",
          "selectedOrderDetails": "__selectedObject.data.0.order"
        }
      },
      {
        "name": "openFTPopup",
        "type": "fnOpenPopup",
        "arg1Key": "popupName",
        "arg1Value": "Factory Ticket"
      },
      {
        "name": "resetFormData",
        "type": "fnCopyData",
        "arg1Key": "sourceKey",
        "arg2Key": "destinationKey",
        "arg2Value": "formData"
      }
    ]
  },
  "forRole": "CUSTOMER_SERVICE_MANAGER,CUSTOMER_SERVICE_OUTBOUND_WAREHOUSE,CUSTOMER_SERVICE_INBOUND_WAREHOUSE,QA_MANAGER",
  "visible": true
}